import {Dispatch} from "redux"
import {connect} from "react-redux"
import {NextComponentType} from "next"

// Actions
import * as a from "../store/actions"

// Models
import {AppState} from "../../../store/models"

// Selectors
import {resetPasswordStateSelector} from "../store/selectors"

export type WithResetPassword = {
    passwordResetSent: boolean
    passwordResetSending: string | null
    resetPassword(email: string): void
}

export default function withResetPassword(BaseComponent: NextComponentType) {
    return connect(
        (state: AppState) => resetPasswordStateSelector(state),
        (dispatch: Dispatch) => ({
            resetPassword: (email: string) => dispatch(a.resetPassword(email)),
        }),
    )(BaseComponent)
}
